(function () {
  if (window.hapicassoCardSlider) return;
  window.hapicassoCardSlider = true;

  var sliders = [];

  function init(root) {
    if (!root || root.getAttribute('data-card-slider-ready') === 'true') return;

    var viewport = root.querySelector('[data-card-slider-viewport]');
    var track = root.querySelector('[data-card-slider-track]');
    var prevBtn = root.querySelector('[data-card-slider-prev]');
    var nextBtn = root.querySelector('[data-card-slider-next]');
    var dots = root.querySelector('[data-card-slider-dots]');
    if (!viewport || !track) return;

    var cards = track.querySelectorAll('.card-slider__card');
    if (!cards.length) return;

    root.setAttribute('data-card-slider-ready', 'true');

    var currentSlide = 0;
    var itemsPerSlide = parseInt(root.getAttribute('data-items-per-slide'), 10) || 4;
    var desktopQuery = window.matchMedia('(min-width: 768px)');

    function totalSlides() {
      return Math.max(1, Math.ceil(cards.length / itemsPerSlide));
    }

    function isDesktop() {
      return desktopQuery.matches;
    }

    function setCardWidths() {
      if (!isDesktop()) {
        track.style.width = '';
        track.style.transform = '';
        cards.forEach(function (card) {
          card.style.flexBasis = '';
        });
        return;
      }

      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
      var viewportWidth = viewport.clientWidth;
      var cardWidth = (viewportWidth - gap * (itemsPerSlide - 1)) / itemsPerSlide;

      cards.forEach(function (card) {
        card.style.flexBasis = cardWidth + 'px';
      });

      track.style.width = cards.length * cardWidth + (cards.length - 1) * gap + 'px';
    }

    function updateDesktopSlider() {
      if (!isDesktop()) return;

      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
      var viewportWidth = viewport.clientWidth;
      var cardWidth = (viewportWidth - gap * (itemsPerSlide - 1)) / itemsPerSlide;
      var offset = currentSlide * itemsPerSlide * (cardWidth + gap);
      var needsNav = cards.length > itemsPerSlide;

      track.style.transform = 'translateX(-' + offset + 'px)';

      if (prevBtn) {
        prevBtn.disabled = currentSlide <= 0;
        prevBtn.classList.toggle('is-hidden', !needsNav);
      }
      if (nextBtn) {
        nextBtn.disabled = currentSlide >= totalSlides() - 1;
        nextBtn.classList.toggle('is-hidden', !needsNav);
      }
    }

    function ensureDots() {
      if (!dots) return;
      var count = dots.querySelectorAll('.card-slider__dot').length;
      if (count === cards.length && dots.querySelector('[data-card-slider-mark]')) return;
      dots.textContent = '';
      for (var i = 0; i < cards.length; i++) {
        var dot = document.createElement('span');
        dot.className = 'card-slider__dot';
        dots.appendChild(dot);
      }
      var mark = document.createElement('span');
      mark.className = 'card-slider__dot-mark';
      mark.setAttribute('data-card-slider-mark', '');
      dots.appendChild(mark);
    }

    function updatePager() {
      if (!dots || isDesktop()) return;
      var maxScroll = viewport.scrollWidth - viewport.clientWidth;
      var progress = maxScroll > 0 ? viewport.scrollLeft / maxScroll : 0;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      var mark = dots.querySelector('[data-card-slider-mark]');
      var dotEls = dots.querySelectorAll('.card-slider__dot');
      if (!mark || dotEls.length < 1) return;
      var first = dotEls[0];
      var last = dotEls[dotEls.length - 1];
      var start = first.offsetLeft + first.offsetWidth / 2;
      var end = last.offsetLeft + last.offsetWidth / 2;
      var x = start + (end - start) * progress - mark.offsetWidth / 2;
      mark.style.transform = 'translateX(' + x + 'px)';
    }

    function resetMobileScroll() {
      if (isDesktop()) return;
      track.style.transform = '';
      if (prevBtn) prevBtn.disabled = true;
      if (nextBtn) nextBtn.disabled = true;
      ensureDots();
      updatePager();
    }

    function refresh() {
      if (!root.isConnected) return;
      setCardWidths();
      if (isDesktop()) {
        currentSlide = Math.min(currentSlide, totalSlides() - 1);
        updateDesktopSlider();
      } else {
        resetMobileScroll();
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (!isDesktop() || currentSlide <= 0) return;
        currentSlide -= 1;
        updateDesktopSlider();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (!isDesktop() || currentSlide >= totalSlides() - 1) return;
        currentSlide += 1;
        updateDesktopSlider();
      });
    }

    viewport.addEventListener(
      'scroll',
      function () {
        if (!isDesktop()) updatePager();
      },
      { passive: true }
    );

    desktopQuery.addEventListener('change', function () {
      currentSlide = 0;
      refresh();
    });

    sliders.push({ refresh: refresh });
    refresh();
    updatePager();
  }

  function boot(scope) {
    var root = scope || document;
    if (root.matches && root.matches('.card-slider[data-items-per-slide]')) {
      init(root);
    }
    root.querySelectorAll('.card-slider[data-items-per-slide]').forEach(init);
  }

  function refreshAll() {
    sliders.forEach(function (slider) {
      slider.refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  window.addEventListener('resize', refreshAll);
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
